import { render, staticRenderFns } from "./app-header.vue?vue&type=template&id=3c58f396&scoped=true&"
import script from "./app-header.vue?vue&type=script&lang=ts&"
export * from "./app-header.vue?vue&type=script&lang=ts&"
import style0 from "./app-header.vue?vue&type=style&index=0&id=3c58f396&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c58f396",
  null
  
)

export default component.exports